module.exports = __webpack_public_path__ + "img/square2.0482707e.png";